import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';
import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

import styles from './ButtonsPayload.styles.m.scss';

interface IButtonsPayloadProps {
  titleClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  message: ChatMessage;
  title: string;
  preventInteraction?: boolean;
  onClick(): void;
}
export const ButtonsPayload: FC<IButtonsPayloadProps> = observer(
  ({
    titleClassName,
    textClassName,
    iconClassName,
    message,
    title,
    onClick,
    preventInteraction,
  }) => {
    const { text, typeDescription } = message.payload;

    if (!message) {
      return null;
    }

    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      <MiniatureMessageLayout
        titleClassName={titleClassName}
        iconClassName={iconClassName}
        title={title}
        messageId={message.id}
        onClick={onClick}
        preventInteraction={preventInteraction}
      >
        <TextRenderer
          isPlainText
          className={classNames(styles.text, textClassName)}
        >
          {text || typeDescription}
        </TextRenderer>
      </MiniatureMessageLayout>
    );
  }
);
